var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorporateFare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16809_65926",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16809_65926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 17.5C2.87533 17.5 2.48296 17.3368 2.15658 17.0104C1.83019 16.684 1.66699 16.2917 1.66699 15.8333V4.16667C1.66699 3.70833 1.83019 3.31597 2.15658 2.98958C2.48296 2.66319 2.87533 2.5 3.33366 2.5H8.33366C8.79199 2.5 9.18435 2.66319 9.51074 2.98958C9.83713 3.31597 10.0003 3.70833 10.0003 4.16667V5.83333H16.667C17.1253 5.83333 17.5177 5.99653 17.8441 6.32292C18.1705 6.64931 18.3337 7.04167 18.3337 7.5V15.8333C18.3337 16.2917 18.1705 16.684 17.8441 17.0104C17.5177 17.3368 17.1253 17.5 16.667 17.5H3.33366ZM3.33366 15.8333H8.33366V14.1667H3.33366V15.8333ZM3.33366 12.5H8.33366V10.8333H3.33366V12.5ZM3.33366 9.16667H8.33366V7.5H3.33366V9.16667ZM3.33366 5.83333H8.33366V4.16667H3.33366V5.83333ZM10.0003 15.8333H16.667V7.5H10.0003V15.8333ZM11.667 10.8333V9.16667H15.0003V10.8333H11.667ZM11.667 14.1667V12.5H15.0003V14.1667H11.667Z",
    fill: "#0129FA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFare);
export default __webpack_public_path__ + "static/media/corporate_fare.2df52906bc5f6816bd3af4eac6731077.svg";
export { ForwardRef as ReactComponent };